import emma from '@/common/services/Emma'

const AnonymousResource = {
	register (username, password) {
		return new Promise((resolve, reject) => {
			let message = 'Une erreur est survenue'
			emma.post('api/anonymous', {
				pseudo: username,
				password: password
			}).then((result) => {
				if (result.data.success) {
					resolve()
				} else {
					reject(new Error(message))
				}
			}).catch((error) => {
				if (error) {
					reject(new Error(message))
				}
			})
		})
	},
	login (username, password) {
		return new Promise((resolve, reject) => {
			let message = 'Pseudo et/ou mot de passe non reconnnu'
			emma.post('api/login', {
				username: username,
				password: password
			}).then((result) => {
				emma.setToken(result.data.refresh_token, result.data.token)
				this.getProfile().then((user) => {
					result.data.user['isEstate'] = (user.data.completed_estate !== 0)
					resolve(result.data)
				}).catch((e) => {
					reject(new Error('Impossible de récupérer le profil de l\'utilisateur'))
				})
			}).catch((error) => {
				if (error) {
					reject(new Error(message))
				}
			})
		})
	},
	getProfile () {
		return emma.get('api/profile')
	}
}

export default AnonymousResource



// WEBPACK FOOTER //
// ./src/resources/Anonymous.js